export const options = {

    apiUrl: 'https://edemes.dltc.spbu.ru/api',
    frontUrl: 'https://edemes.dltc.spbu.ru'

};
